import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useUnmatchMutation as UseUnmatchMutation,
  type useUnmatchMutation$data
} from '@/__generated__/useUnmatchMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useUnmatchMutation$data>

export const useUnmatchMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseUnmatchMutation>(graphql`
    mutation useUnmatchMutation($input: DeleteMatchInput!) {
      deleteMatch(input: $input) {
        query {
          currentUserUnreadCount
          currentUser {
            ...MessagesView_user
          }
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (rowId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors[0])
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              rowId
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
